import { Reveal } from "./Reveal";
import { scrollToId } from "@/data";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative">
      <div className="relative min-h-[88svh] flex items-end overflow-hidden">
        <img
          src="/images/final-cta.jpg"
          alt="AuraXR devices on a teacher's desk in a bright classroom"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover object-[center_75%]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050811] via-[#050811]/45 to-[#050811]/15" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050811]/70 via-transparent to-transparent" />

        <div className="relative z-10 mx-auto w-full max-w-[1440px] px-6 lg:px-12 pb-24 sm:pb-32">
          <Reveal>
            <h2
              data-testid="final-cta-heading"
              className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight text-[#FFFDF9] max-w-3xl"
            >
              The classroom is already there.
              <br />
              We're adding another way to{" "}
              <span className="italic text-[#38BDF8]">see it</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <button
                data-testid="final-cta-explore"
                onClick={() => scrollToId("devices")}
                className="rounded-full bg-[#38BDF8] px-8 py-3.5 text-sm font-semibold text-[#050811] transition-all duration-300 hover:bg-[#7dd3fc] hover:shadow-[0_0_40px_rgba(56,189,248,0.35)]"
              >
                Explore AuraXR
              </button>
              <a
                data-testid="final-cta-join"
                href="mailto:xraura.ai@gmail.com?subject=Joining%20the%20AuraXR%20journey"
                className="text-sm text-slate-200 hover:text-[#38BDF8] transition-colors duration-300 tracking-wide border-b border-slate-500/60 hover:border-[#38BDF8] pb-0.5"
              >
                Join the journey
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
